<template>
  <section class="section" id="contact" ref="contact">
    <b-container>
      <b-row>
        <transition name="fade">
          
          <b-col cols="12" class="">
            <div class="title-wrapper">
              <span>
                <h2 class="font-bad font-weight-bold text-center mb-0"> Let's work together!! </h2>
              </span>
            </div>
            <div class="form-container">
              <form 
                name="contact-me"
                id="contact-form" 
                class="mx-auto"
                data-netlify="true"
                data-netlify-honeypot="bot-field"
                method="POST">
                 <input type="hidden" name="form-name" value="contact-me" />
                <b-form-row>
                  <b-alert
                    class="col-12 mb-4 text-left"
                    :show="alert.dismissCountDown"
                    dismissible
                    :variant="alert.variant"
                    @dismissed="alert.dismissCountDown=0"
                    @dismiss-count-down="countDownChanged"
                  >
                    <p>{{ alert.message }}</p>
                    <ul v-if="alert.errorList.length > 0">
                      <li v-for="(error, index) in alert.errorList" :key="index">
                        {{ error }}
                      </li>
                    </ul>
                    <b-progress
                      :variant="alert.variant"
                      :max="alert.dismissSecs"
                      :value="alert.dismissCountDown"
                      height="4px"
                    ></b-progress>
                  </b-alert>
                </b-form-row>
                <b-form-row>
                  <b-col>
                    <b-input 
                    type="text"
                    class="form-input custom-input"
                    placeholder="Name"
                    v-model="form.name"
                    name="name"
                    ></b-input>
                  </b-col>
                  <b-col>
                    <b-input 
                    type="email"
                    class="form-input custom-input"
                    placeholder="Email"
                    v-model="form.email"
                    name="email"
                    ></b-input>
                  </b-col>
                </b-form-row>
                <b-form-row class="mt-4">
                  <b-col>
                    <b-form-select v-model="form.subjectSelected" :options="form.subjectOpts"
                    class="custom-input custom-box"
                    name="subject"></b-form-select>
                  </b-col>
                </b-form-row>
                <b-form-row class="mt-4">
                  <b-col>
                    <b-form-textarea
                      id="textarea"
                      class="custom-input"
                      v-model="form.message"
                      placeholder="Leave your message here.."
                      size="sm"
                      name="message"
                    ></b-form-textarea>
                  </b-col>
                </b-form-row>
                <b-form-row class="mt-4">
                  <b-col class="text-right">
                    <!--<SimpleButton
                      :btnType="'submit'"
                      :text="'Send'"
                      class="">
                    </SimpleButton>-->
                    <CustomButton
                      :btnType="'submit'"
                      class="font-bad arrow-right-btn">
                      <template>
                        <i class="fas fa-paper-plane mr-2"></i>
                        Send Message
                      </template>
                    </CustomButton>
                  </b-col>
                </b-form-row>
              </form>
            </div>
          </b-col>
        </transition>
      </b-row>
    </b-container>
  </section>
</template>

<script>
import axios from 'axios'
//import SimpleButton from '@/components/SimpleButton.vue'
import CustomButton from '@/components/CustomButton.vue'
export default {
  components: {  CustomButton },
  data() {
    return {
      form: {
        subjectSelected: null,
        subjectOpts:[
          { value: null, text: 'Please select a subject' },
          { value: 'consulting', text: 'Consulting' },
          { value: 'course', text: 'Courses' },
          { value: 'event', text: 'Events' },
          { value: 'project', text: 'Project' },
          { value: 'job', text: 'Job' },
        ],
        name: '',
        email: '',
        message: '',
      },
      errorMsgs: [],
      alert:{
        show: false,
        variant: 'success',
        message: 'Thank you for getting in touch! I will contact you as soon as possible.',
        errorList: [],
        dismissSecs: 10,
        dismissCountDown: 0,
      }
    }
  },
  methods: {
    countDownChanged(dismissCountDown) {
      this.alert.dismissCountDown = dismissCountDown;
    },
    sendContactForm(){
      let isValidForm = this.validateForm();
      //console.log('>>> isValidForm ', isValidForm);
      //console.log(this.errorMsgs);
      if(isValidForm){
        axios.post('/contact.php', {
          name: this.form.name, 
          email: this.form.email,
          message: this.form.message,
          msgsubject: this.form.subjectSelected
        }).then(httpResponse => {
          console.log(httpResponse);
          if(httpResponse.status == 200){
            this.setSuccessAlert();
          }else{
            this.setErrorAlert('Ooops! Something went wrong, please try again', false);
          }
         
        }).catch( () => {
          
            this.setErrorAlert('Ooops! Something went wrong, please try again', false);
        })
      }else{
        this.setErrorAlert('Please check the followig errors:', true);
      }
    },
    contactSubmit(){
      if(this.validateForm() === true)
        this.setSuccessAlert();
      else
        this.setErrorAlert('Please check the followig errors:', true);
    },
    validateForm(){
      this.errorMsgs = [];
      let isValid = true;
      if(this.form.email == ''){
        this.errorMsgs.push('Email input is required');
        isValid = false
      }else if (!this.validEmail(this.form.email)) {
        this.errorMsgs.push('Email format is wrong');
        isValid = false;
      }
      if(this.form.name == ''){
        this.errorMsgs.push('Name input is required');
        isValid = false
      }
      if(this.form.message == ''){
        this.errorMsgs.push('Message input is required');
        isValid = false
      }
      return isValid;
    },
    
    validEmail: function (email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    setSuccessAlert(){
      this.alert.show = true;
      this.alert.variant = 'success';
      this.alert.message = 'Thanks for contacting me! I will contact you as soon as possible.';
      this.alert.errorList = [];
      this.alert.dismissSecs = 5;
      this.alert.dismissCountDown = 0;
      this.alert.dismissCountDown = this.alert.dismissSecs;//show alert
    },
    setErrorAlert(msg, showErrorList){
      this.alert.errorList = [];
      this.alert.show = true;
      this.alert.variant = 'danger';
      if(showErrorList){
        this.alert.errorList = this.errorMsgs;
      }
      this.alert.message = msg;
      this.alert.dismissSecs = 7;
      this.alert.dismissCountDown = 0;
      this.alert.dismissCountDown = this.alert.dismissSecs;//show alert
    }
  },
  computed: {
    
  }
}
</script>

<style>
  .alert{
    background: transparent;
    border-radius: 0;
    color:#fff;
    padding-left: 1rem !important;
    padding-right: 1rem !important;
  }
  .alert .close{
    color: #fff;
  }
</style>
<style>
.contact-section{
  padding-top: 3rem;
  padding-bottom: 8rem;
}
.outside-box{

  width: 90%;
  height: 300px;
  padding: 2rem 1.5rem;
}
.outside-box >h2{
  text-align: left;
  color: #2C2B30;
}
.inside-box{
  width: 120%;
  padding: 2rem 1.5rem;
  text-align: left;
  color: #000;
}
.inside-box p{
  font-size: 20px;
}
#contact-form{
  max-width: 800px;
  margin-left: auto;
  border: 4px solid #2C2B30;
  background-color: #2C2B30;
  padding: 2rem 1.5rem;
}

.arrow-right{
  font-size: 34px !important;
}
.custom-input{
  border-radius: 0;
  background: none;
  border: none;
  border-bottom: 1px solid var(--pink-accent);
  color: #fff !important;
}
.custom-input:focus{
  outline: none;
  box-shadow: none;
  background: transparent;
  border-bottom: 2px solid var(--pink-accent);
  border-color: var(--pink-accent);
}
.custom-input::placeholder,
.custom-select{
  color: var(--gray-light) !important;
  font-size: 16px;
}

.custom-box{
  border: 1px solid var(--pink-accent);
}
.custom-box option{
  background: var(--gray-dark);
}
.custom-box:focus{
  border: 2px solid var(--pink-accent);
}

@media (min-width: 768px){
  .contact-section{
    padding-top: 4rem;
    padding-bottom: 8rem;
  }
}
@media (min-width: 992px){
  .contact-section{
    padding-top: 4rem;
    padding-bottom: 6rem;
  }
}
</style>